module.exports = __webpack_public_path__ + "media/checkmate.a8eac9cd.mp3";